export default __webpack_public_path__ + "static/media/DE.46302eb0.svg";